







































import { getConfig } from '@superbet-group/web.lib.config';
import { RouteName } from '@app/router/constants/RouteName';
import { getCountryActivateAccountMainButton } from '@modules/authentication/activateAccountMainButton';
import { shellLocalConfig } from '@src/config/shell/localConfig';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import { errorGuard } from '@utils/ErrorGuard';
import { antiFraudService } from '@core/services/antiFraud/AntiFraudService';
import {
    AnalyticsScreenNames,
    AnalyticsModalNames,
} from '@app/utils/analyticsScreenNames';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import {
    computed,
    defineComponent,
    onMounted,
    ref,
} from '@vue/composition-api';
import authStore from '@store/modules/data/authentication/authenticationIndex';
import modalIndex from '@store/modules/ui/shared/modal/modalIndex';
import {
    useVueRouter,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import {
    SdsButton,
    SdsContentLoader,
    SdsIllustration,
} from '@superbet-group/web.lib.ui-components';
import { getAccountConfig } from '@accountFederation/config/accountConfig';
import { capitalize } from '@superbet-group/web.lib.utilities';

const State = {
    Loading: 'Loading',
    Success: 'Success',
    Error: 'Error',
};

export default defineComponent({
    name: 'ActivateAccountContainer',
    setup() {
        const { router, pushRoute } = useVueRouter();

        const activationState = ref(State.Loading);

        const authModule = useVuexStore<typeof authStore>('data/authentication');
        const activateAccount = authModule.action('activateAccount');

        const modalModule = useVuexStore<typeof modalIndex>('ui/modal');
        const setModal = modalModule.action('setModal');

        const isResponsibleLimitButtonShown = getConfig().countrySpecific.auth.activateAccount?.isResponsibleLimitButtonShown;
        const isCompleteAccountActivationModalEnabled = shellLocalConfig.isCompleteAccountActivationModalEnabled;

        function goToResponsiblePage() {
            pushRoute({ name: RouteName.Account.ResponsibleGaming });
        }

        function sendClickStreamEvent(modalName: string) {
            AnalyticsSDK.getInstance().log('account_open', {
                screen_name: AnalyticsScreenNames.activateAccount,
                modal_name: modalName,
            });
        }

        onMounted(async () => {
            if (shellLocalConfig.seonConfig.register.isServiceEnabled) {
                await antiFraudService.initialize(getConfig().antiFraud);
            }

            const isScreenOpenAccountOpenSent = shellLocalConfig.isScreenOpenAccountOpenSent;
            await errorGuard(
                async () => {
                    await activateAccount(router.value.currentRoute.query.activationCode);
                    activationState.value = State.Success;

                    if (isScreenOpenAccountOpenSent) {
                        sendClickStreamEvent(AnalyticsModalNames.accountActivationSuccess);
                    }

                    AnalyticsSDK.getInstance().log('Account_Activated');

                    if (isCompleteAccountActivationModalEnabled && !getAccountConfig().hasKycCaptive) {
                        setModal({
                            code: modalCodes.completeAccountActivation,
                            isClosable: true,
                        });
                        pushRoute({ name: RouteName.App.Home });
                    }
                }, {
                    onError: (error) => {
                        activationState.value = State.Error;

                        setModal({
                            isClosable: false,
                            code: modalCodes.activationLinkExpired,
                        });

                        if (isScreenOpenAccountOpenSent) {
                            sendClickStreamEvent(AnalyticsModalNames.accountActivationError);
                        }

                        AnalyticsSDK.getInstance().log('Account_Activation_Error', {
                            errorMessage: error.message || 'unknown',
                        });
                    },
                },
            );
        });

        return {
            State,
            activationState,
            isResponsibleLimitButtonShown,
            goToResponsiblePage,
            shouldRemoveBottomPadding: computed(() => activationState.value === State.Success && isResponsibleLimitButtonShown),
            brandName: shellLocalConfig.logo,
            capitalize,
        };
    },
    components: {
        ActivateAccountMainButton: getCountryActivateAccountMainButton(getConfig().countrySpecific.country),
        SdsContentLoader,
        SdsIllustration,
        SdsButton,
    },
});
